import api from "@/api/RepositoryFactory.js";
/* eslint-disable */

const state = () => ({
    errorOnLaunch: "",
    createdSurvey: null,
    createdSurveyError: null,
});

const getters = {
    getLaunchError: (state) => {
        return state.errorOnLaunch;
    },
    getCreatedSurvey: (state) => {
        return state.createdSurvey;
    },
    getCreatedSurveyError: (state) => {
        return state.createdSurveyError;
    }
};

const actions = {
    async launchSurvey({ commit }, id) {
        try {
            commit("SET_LAUNCH_ERROR", "");
            await api.editCreate.launchSurvey(id);
        } catch (e) {
            if (e && e.response && e.response.status) {
                commit("SET_LAUNCH_ERROR", e.response.status);
            }
            console.log(e, e.response.status);
        }
    },
    async stopSurvey(_, id) {
        try {
            await api.editCreate.stopSurvey(id);
        } catch (e) {
            console.log(e, { ...e });
        }
    },
    async createSurvey({ commit }, params) {
        try {
            commit("SET_CREATED_SURVEY", null);
            const response = await api.editCreate.createSurvey(params);
            commit("SET_CREATED_SURVEY", response.data.result);
        } catch (e) {
            if (e.response) {
                commit("SET_CREATED_ERROR", e.response)
            }
            console.log(e, { ...e });
        }
    },
    async updateSurvey(_, params) {
        try {
            await api.editCreate.updateSurvey(params.line_item_id, params);
        } catch (e) {
            console.log(e, { ...e });
        }
    },
};

const mutations = {
    SET_LAUNCH_ERROR(state, data) {
        let text = "";
        if (data) {
            switch (data) {
                case 400:
                    text = "Запрос не выполнен 400";
                    break;
                case 404:
                    text = "404";
                    break;
            }
        }
        state.errorOnLaunch = text;
    },
    SET_CREATED_SURVEY(state, data) {
        state.createdSurvey = data;
    },
    SET_CREATED_ERROR(state, data) {
        state.createdSurveyError = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
